import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            columns_for_tables: {
              settings_table_columns: {
                selected_columns: 'ENABLED',
                unselected_columns: 'DISABLED',
                save: 'SAVE',
                back: 'BACK',
              },
            },
          },
        },
      },
    },
  }));
}
